module.exports = __webpack_public_path__ + "static/media/1.c05958b9.svg";